import { render, staticRenderFns } from "./HeaderChat.vue?vue&type=template&id=28fc01a2&scoped=true&"
import script from "./HeaderChat.vue?vue&type=script&lang=js&"
export * from "./HeaderChat.vue?vue&type=script&lang=js&"
import style0 from "./HeaderChat.vue?vue&type=style&index=0&id=28fc01a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fc01a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VRow})
